/* eslint-disable react/no-unused-class-component-methods */
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Dialog } from '~/components';

import Google from './google';

class Edit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
      params: {},
      mapVisible: false,
    };
  }

  // Toggle modal
  async handleToggleModal(params = {}) {
    this.setState({
      open: true,
      params,
      mapVisible: false,
    });
  }

  // Close modal
  async handleCloseModal() {
    await this.setState({ open: false, params: {}, mapVisible: false });
  }

  handleEntered() {
    this.setState({ mapVisible: true });
  }

  handleExited() {
    this.setState({ mapVisible: false });
  }

  render() {
    const { open, params, mapVisible } = this.state;

    return (
      <Dialog
        open={open}
        toggle={() => this.handleCloseModal()}
        title={params.descricaocercavirtual}
        onEntered={() => this.handleEntered()}
        onExited={() => this.handleExited()}
      >
        <Google open={open} visible={mapVisible} id={params.idcercavirtual} />
      </Dialog>
    );
  }
}

export default connect(null, null, null, { forwardRef: true })(Edit);
